module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Rose Gold + Lavender Open.b0ba4521.png";